import React from "react";
import { Typography, Box, Container } from "@material-ui/core";

export default function PrivacyPage() {
  return (
    <div>
      <PrivacyContent />
    </div>
  );
}

const privacyTerms = [
  {
    title: "富屋法拍屋",
    content1:
      "尊重您的隱私權。本「隱私權聲明」的目的在告知您我們對於隱私權保護的做法，和對於線上資訊的蒐集您可做的選擇以及這些資訊將如何被使用。",
    content2:
      "以下說明:富屋法拍屋,http://www.5137.com.tw（以下簡稱本網站或富屋)對會員及瀏覽者個人資料的蒐集、處理及利用，之規範及用途。",
  },
  {
    title: "1.適用本「隱私權聲明」的網站",
    content1:
      "在於本網站域名及次級網域名中的網頁，其餘理開本網站的第三方網站包括廣告連結等，富屋無法控制那些網站及其對於隱私權保護的做法，它們可能和富屋的做法不同。我們不為第三方網站背書，也不對任何第三方網站提供保證。",
  },
  {
    title: "2. 資料的紀錄",
    content1:
      "本網站之伺服器會自動記錄您所閱讀的網頁、您所來自的網域名稱，作為內容與系統改進、廣告效果評估等依據。此一部份資訊，不涉及會員個人身份資料，只用來作數據性的統計分析，除供內部參考外，並將提供給廣告商及本網站內之各會員公司提取cookie使用，作為廣告效果評估之依據。本網站將於本聲明範圍內為運用，絕不會任意透露、出售、交換、或出租給其他第三人、單位及團體，並且嚴禁內部人員私自使用這些資料。",
  },
  {
    title: "3.資料的蒐集",
    content1:
      "我們會依據你在我們網站上的行為自動收集一些必要資料，我們使用這些資料來統計會員的，興趣，年齡，性別，行為模式，來進行內部研究，以便更瞭解我們的會員，這些資料可能包括你剛來自於那個URL(不論這個URL是否在我們的網站上)，你接下來前往的URL(不論這個URL是否在我們的網站上)，目前使用何種瀏覽器，以及你的IP地址。",
  },
  {
    title: "4.關於會員資料",
    content1:
      "使用本網站某些頁面,本網站可能會要求加入會員才得以使用當中的功能，在您加入會員時本網站可能會要求您的一些個人資料如:年齡、性別、職業、聯絡電話、電子信箱地址等，其目的是要增加對會員的瞭解，並提供更佳的服務。",
  },
  {
    title: "5.我們如何使用您的資料",
    content1:
      "我們會使用在，紀錄，分析，提供服務，提供您有關新的服務與優惠訊息，選擇與您溝通的內容以及提供適合的服務，及重要消息",
  },
  {
    title: "6. 我們如何分享您的資料",
    content1:
      "本網站如為了提供您其他服務或優惠權益（例如折價券），需要與提供該服務或優惠之第三者共用您的資料時，會在活動舉辦或公告同時提供充分說明，並經您同意後方將您的資料傳輸予第三者，您可以自由選擇是否接受這項特定服務或優惠。",
  },
  {
    title: "7.變更及修改",
    content1:
      "為了因應社會環境及法令規定的變遷與科技的進步，本網站為保護會員隱私，有權配合當時法令、環境等隨時修改公告並儘速公告週知。",
  },
];

function PrivacyContent() {
  return (
    <div>
      <Container maxWidth="lg">
        <Box py={8}>
          {privacyTerms.map((item) => {
            return (
              <>
                <Box my={5}>
                  <Typography
                    variant="h4"
                    color="primary"
                    style={{ fontWeight: "bold" }}
                  >
                    {item.title}
                  </Typography>
                </Box>

                <Box my={4}>
                  <Typography variant="body1">{item.content1}</Typography>
                </Box>

                <Box
                  my={4}
                  style={{ display: item.content2 ? "block" : "none" }}
                >
                  <Typography variant="body1">{item.content2}</Typography>
                </Box>
              </>
            );
          })}
        </Box>
      </Container>
    </div>
  );
}
